function formatCoordinateInput(value, previousValue) {
  const rawValue = String(value || "");

  // Otomatik virgül silinirken kullanıcıyı aynı konumda kilitlememek için ikinci rakamı da sil.
  if (String(previousValue || "").endsWith(",") && rawValue === previousValue.slice(0, -1)) {
    return rawValue.slice(0, -1);
  }

  const isNegative = rawValue.trimStart().startsWith("-");
  const digits = rawValue.replace(/\D/g, "");
  const sign = isNegative ? "-" : "";

  if (digits.length < 2) return `${sign}${digits}`;
  return `${sign}${digits.slice(0, 2)},${digits.slice(2)}`;
}

// Functional parity split from App.js; App keeps coordinate search state and handlers.
export default function CoordinateSearchModal({
  coordinateSearchError,
  coordinateSearchX,
  coordinateSearchY,
  onClear,
  onClose,
  onSubmit,
  setCoordinateSearchError,
  setCoordinateSearchX,
  setCoordinateSearchY,
}) {
  return (
    <div className="coordinate-modal" role="dialog" aria-modal="true">
      <form className="coordinate-modal__panel" onSubmit={onSubmit}>
        <div className="coordinate-modal__header">
          <h2 className="coordinate-modal__title">Koordinat Ara</h2>
          <button
            type="button"
            className="coordinate-modal__close"
            onClick={onClose}
            aria-label="Koordinat aramasını kapat"
          >
            ×
          </button>
        </div>
        <div className="coordinate-modal__body">
          <label className="coordinate-modal__field">
            <span>Y</span>
            <input
              type="text"
              value={coordinateSearchY}
              onChange={(event) => {
                setCoordinateSearchY(
                  formatCoordinateInput(event.target.value, coordinateSearchY)
                );
                if (coordinateSearchError) setCoordinateSearchError("");
              }}
              placeholder="38,5588999"
              autoFocus
            />
          </label>
          <label className="coordinate-modal__field">
            <span>X</span>
            <input
              type="text"
              value={coordinateSearchX}
              onChange={(event) => {
                setCoordinateSearchX(
                  formatCoordinateInput(event.target.value, coordinateSearchX)
                );
                if (coordinateSearchError) setCoordinateSearchError("");
              }}
              placeholder="32,1144556"
            />
          </label>
          {coordinateSearchError ? (
            <div className="coordinate-modal__error">{coordinateSearchError}</div>
          ) : null}
        </div>
        <div className="coordinate-modal__footer">
          <button
            type="submit"
            className="coordinate-modal__button coordinate-modal__button--primary"
          >
            Koordinat Ata
          </button>
          <button
            type="button"
            className="coordinate-modal__button"
            onClick={onClear}
          >
            Temizle
          </button>
          <button
            type="button"
            className="coordinate-modal__button"
            onClick={onClose}
          >
            İptal
          </button>
        </div>
      </form>
    </div>
  );
}
